<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    let token = localStorage.coeToken
    if (!token && this.$route.name !== 'logout') {
      this.$router.replace({
        name: 'login'
      })
    }
  }
}
document.oncopy = replaceDot
function replaceDot () {
  let bodyElement = document.body
  let selection = window.getSelection()
  if (window.clipboardData) { // Internet Explorer
    let copytext = selection
    if (!isNaN(parseFloat(copytext.toString().replace(/,/g, '')))) {
      window.clipboardData.setData('Text', copytext.toString().replace(/,/g, ''))
      return false
    }
  } else {
    let copytext = selection
    if (!isNaN(parseFloat(copytext.toString().replace(/,/g, '')))) {
      var newdiv = document.createElement('div')
      newdiv.style.position = 'absolute'
      newdiv.style.left = '-99999px'
      bodyElement.appendChild(newdiv)
      newdiv.innerHTML = copytext.toString().replace(/,/g, '')
      selection.selectAllChildren(newdiv)
      window.setTimeout(function () {
        bodyElement.removeChild(newdiv)
      }, 0)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #1E1E1E;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue